import 'xterm/css/xterm.css';
import './styles/ConsolaHost.css'
import React, { useEffect, useRef, useState } from 'react';
import LoadSimple from './LoadSimple';
import { Terminal } from 'xterm';



const ConsolaHost = (props) => {
    const ws = useRef(null);
    const consola = useRef(null);

    const terminalRef = useRef(null);
    const commandBufferRef = useRef('');

    // console.log(consola.current)
    const [conectionActive, setConectionActive] = useState(false)
    const [msgConection, setMsgConection] = useState('Estableciendo conexíon. . .')
    const contenedorRef = useRef(null);

    // useEffect(() => {
    //   scrollAbajo();
    // }, []);

    // function scrollAbajo() {
    //   if (terminalRef.current) {
    //     terminalRef.current.scrollTop = terminalRef.current.scrollHeight;
    //   }
    // }
    const formatearTexto = (objeto) => {
        if (!objeto) return '';
        // Dividir el texto en líneas
        const lineas = objeto.split('\n');
        return lineas;
    };
    useEffect(() => {
        const xterm = new Terminal({
            cursorBlink: true,
            theme: {
                background: '#1e1e1e',
                foreground: '#ffffff',
            },
        });

        xterm.open(terminalRef.current);
        ws.current = new WebSocket(props.server.ws + '/api/v1/zabbix/hosts/ws_terminal');

        ws.current.onopen = function (event) {
            ws.current.send('hosttarget:' + props.ip);
            xterm.writeln('Conexión WebSocket abierta.');
        };

        ws.current.onmessage = function (event) {
            xterm.write(event.data);
        };

        ws.current.onclose = function (event) {
            xterm.writeln('Conexión WebSocket cerrada.');
            props.actionConsole()
        };

        // xterm.onData((data) => {
        //     if (data === '\r') {
        //         ws.current.send(commandBufferRef.current);
        //         commandBufferRef.current = '';
        //         xterm.write('\r\n');
        //     } else if (data === '\x7f') { // Carácter de retroceso
        //         if (commandBufferRef.current.length > 0) {
        //             commandBufferRef.current = commandBufferRef.current.slice(0, -1); // Eliminar el último carácter
        //             xterm.write('\b \b'); // Retroceder y borrar el carácter en la interfaz
        //         }
        //     } else {
        //         commandBufferRef.current += data;
        //         xterm.write(data);
        //     }
        // });
        xterm.onData((data) => {
            // Intercepta Ctrl+C
            if (data === '\x03') {
                ws.current.send('\x03');
                commandBufferRef.current = ''; // Optionally clear command buffer
                xterm.write('^C\r\n');
            } else if (data === '\r') {
                ws.current.send(commandBufferRef.current);
                commandBufferRef.current = '';
                xterm.write('\r\n');
            } else if (data === 'OA') {
                ws.current.send('OA');
                commandBufferRef.current = '';
                xterm.write('\r\n');
            } else if (data === 'OB') {
                // Flecha abajo
                // Enviar alguna operación o comando de tu backend para manejar esto
                ws.current.send('OB');
                xterm.write('\r\n');
                commandBufferRef.current = '';
            } else if (data === '[A') {
                commandBufferRef.current = '';
            }
            else if (data === '[B') {
                commandBufferRef.current = '';
            } else if (data === '\x7f') { // Carácter de retroceso
                if (commandBufferRef.current.length > 0) {
                    commandBufferRef.current = commandBufferRef.current.slice(0, -1); // Eliminar el último carácter
                    xterm.write('\b \b'); // Retroceder y borrar el carácter en la interfaz
                }
            }

            else {
                commandBufferRef.current += data;
                xterm.write(data); // Eco local del carácter ingresado
            }
        });

        return () => {
            // const commandContainer = document.createElement('span');
            //     commandContainer.textContent = `Ocurrio un error, Cerrando Conexíon...`;
            //     commandContainer.classList.add('cancelDiv');
            //     // consola.current.innerHTML = '';
            // consola.current.append(commandContainer);
            ws.current.close();
        };
    }, []);
    function appendMessageAndPrompt(userHost, message) {
        setConectionActive(true)

        if (message) {
            var lineas = formatearTexto(message)
            const messageDiv = document.createElement('div');
            // messageDiv.textContent = formatearTexto(message);
            messageDiv.className = 'responseDiv'
            lineas.map((linea, index) => {
                const lineDiv = document.createElement('p');
                lineDiv.textContent = linea;
                lineDiv.className = 'contResponseDiv'
                lineDiv.id = index
                messageDiv.append(lineDiv)
            });

            consola.current.appendChild(messageDiv);

        } else {
            const messageDiv = document.createElement('div');
            messageDiv.textContent = ' ';
            consola.current.appendChild(messageDiv);
        }
        // Mostrar el prompt de user@host
        const promptSpan = document.createElement('span');
        promptSpan.classList.add('prompt');
        promptSpan.textContent = `${userHost}> `;
        consola.current.appendChild(promptSpan);
        // Crear el input para el nuevo comando
        const input = document.createElement('input');
        input.type = 'text';
        input.classList.add('command-input');

        input.addEventListener('keydown', async function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                const command = input.value;
                ws.current.send(command); // Enviar el comando al servidor
                // Crear un contenedor para el prompt y el comando
                const commandContainer = document.createElement('span');
                commandContainer.textContent = `${userHost}> `;
                commandContainer.classList.add('command-container');
                const messageDiv = document.createElement('div');
                messageDiv.textContent = ` ${command}`;
                messageDiv.className = 'commandReq'
                promptSpan.appendChild(messageDiv);
                commandContainer.appendChild(messageDiv);
                // Reemplazar el input y el prompt por el contenedor del comando en la consola
                promptSpan.removeChild(input);
                consola.current.replaceChild(commandContainer, promptSpan);
                // Añadir nueva línea después del comando enviado
                const newLine = document.createElement('div');
            }
        });

        // Añadir el input al DOM y enfocarlo
        promptSpan.appendChild(input);
        input.focus();
        // Asegurar que la consola se desplace hacia abajo automáticamente
        consola.current.scrollTop = consola.current.scrollHeight;
    }
    function closeSSH() {
        // const commandContainer = document.createElement('span');
        //         commandContainer.textContent = `Cerrando Conexíon...`;
        //         commandContainer.classList.add('cancelDiv');
        //         consola.current.innerHTML = '';
        //     consola.current.append(commandContainer);
        ws.current.close();
    }
    return (
        // <>
        // <div id="terminal" ref={terminalRef}></div>
        // </>
        <>
            <div className='contConsolTitle' style={{
                position: 'relative',
                height: '50px',
                background: '#0f172a',
                color: '#f8fafc',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 20px',
                borderBottom: '1px solid #334155'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{
                        width: '32px',
                        height: '32px',
                        background: '#1e293b',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #334155'
                    }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#38bdf8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="2" y="2" width="20" height="20" rx="2" ry="2"></rect>
                            <path d="M7 8l5 5 5-5"></path>
                        </svg>
                    </div>
                    <span style={{ fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        SSH Terminal: <span style={{ color: '#38bdf8', fontFamily: 'monospace' }}>{props.ip}</span>
                    </span>
                </div>

                <div
                    onClick={() => closeSSH()}
                    style={{
                        cursor: 'pointer',
                        width: '30px',
                        height: '30px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '6px',
                        transition: 'background 0.2s',
                        right: '5%',
                        position: 'relative',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#ef4444'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                >
                    <svg width="18" height="18" viewBox="0 0 14 14">
                        <line x1="2" y1="2" x2="12" y2="12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                        <line x1="12" y1="2" x2="2" y2="12" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
            </div>
            <div className='contConsolaHost' style={{ width: '100%', height: 'calc(100% - 50px)', top: 0, position: 'relative', border: 'none', borderRadius: 0, background: '#1e1e1e' }}>
                <div className='contConsolText' id="terminal" ref={terminalRef} style={{ width: '100%', height: '100%', padding: '15px', boxSizing: 'border-box' }}>
                </div>
            </div>
        </>
    );
}

export default ConsolaHost